export class ClsMenuNegocioAppModel {
  public MN_ID :number;
  public MN_MENU_ID: number;
  public MN_NEGOCIO_ID: number;
  public MN_ESTADO:string;
  public MN_IP_EQUIPO: string;
  public MN_MOSTRAR_IMAGEN: string;
}
